import React, { useState } from 'react'
import FileIcon from '@mui/icons-material/InsertDriveFile'
import clsx from 'clsx'
import { ListItem, ListItemText, ListItemAvatar } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useIntl } from 'react-intl'
import ModalEditFileNameInline from '../../modals/ModalEditFileNameInline'
import IconButton from '../../Button/IconButton'
import { useDropzoneContext } from '../../../contexts/DropzoneContext'
import ButtonGroup from '../../Button/ButtonGroup'

export type DropzoneFileListItemProps = {
	file: File
}

const DropzoneFileListItem = ({
	file,
}: DropzoneFileListItemProps) => {
	const { onRemoveFile, onUpdateFileName } = useDropzoneContext()
	const { formatMessage } = useIntl()

	const [editFileNameModalOpen, setEditFileNameModalOpen] =
		useState(false)

	const handleOpenEditFileNameModal = () => {
		setEditFileNameModalOpen(true)
	}

	const handleCloseEditFileNameModal = () => {
		setEditFileNameModalOpen(false)
	}

	const handleRemoveFile = () => {
		onRemoveFile(file)
	}

	return (
		<ListItem>
			<ListItemAvatar
				className={clsx(editFileNameModalOpen && 'hidden md:block')}
			>
				<FileIcon />
			</ListItemAvatar>
			<div className="relative w-full flex-1">
				<ListItemText primary={file.name} />
				{onUpdateFileName && (
					<ModalEditFileNameInline
						onSubmit={onUpdateFileName}
						onClose={handleCloseEditFileNameModal}
						visible={editFileNameModalOpen}
						file={file}
					/>
				)}
			</div>
			{!editFileNameModalOpen && (
				<ButtonGroup
					overflowLimit={2}
					items={[
						<IconButton
							key="edit-file-name"
							tooltipTitle={formatMessage({ id: 'global.rename' })}
							onClick={handleOpenEditFileNameModal}
						>
							<EditIcon color="primary" />
						</IconButton>,
						<IconButton
							key="remove-file"
							tooltipTitle={formatMessage({
								id: 'remove_record.remove',
							})}
							onClick={handleRemoveFile}
						>
							<DeleteIcon color="error" />
						</IconButton>,
					]}
				/>
			)}
		</ListItem>
	)
}

export default DropzoneFileListItem
